/**
 * Get all the properties (of a geojson feature properties).
 */

import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'

export default function (object) {
  if (isNil(object) || !isObject(object)) {
    console.log('GetPropertiesAll - Invalid properties object!', object)
  }

  return { ...object }
}
